import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '../lib/format';

/**
 * Phân trang.
 *
 * Mọi danh sách đều phân trang — kỷ luật query của CLAUDE.md, và cũng vì một
 * tenant cấp sở có hàng chục nghìn bài.
 */
export function Pagination({
  total,
  limit,
  offset,
  onChange,
}: {
  total: number;
  limit: number;
  offset: number;
  onChange: (offset: number) => void;
}): ReactNode {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage ?? 'vi';

  if (total === 0) return null;

  const from = offset + 1;
  const to = Math.min(offset + limit, total);

  return (
    <nav className="pagination" aria-label={t('paging.next')}>
      <button
        type="button"
        disabled={offset === 0}
        onClick={() => onChange(Math.max(offset - limit, 0))}
      >
        {t('paging.previous')}
      </button>
      <span>
        {t('paging.rangeOfTotal', {
          from: formatNumber(from, locale),
          to: formatNumber(to, locale),
          total: formatNumber(total, locale),
        })}
      </span>
      <button type="button" disabled={to >= total} onClick={() => onChange(offset + limit)}>
        {t('paging.next')}
      </button>
    </nav>
  );
}
